import React from "react";
import "./components.css";

export default function HeroSection() {
  return (
    <section className="hero-alt">
      <div className="hero-alt-content">
        <h1 className="hero-alt-title">🎉 Discover Events Near You</h1>
        <p className="hero-alt-subtitle">Music • Culture • Tech • Community</p>
        <a href="#events" className="hero-alt-button">Browse Events</a>
      </div>
    </section>
  );
}
